import React, { useState, useEffect, useRef } from 'react';
import { Container, Button, Alert } from 'react-bootstrap';
import JsBarcode from 'jsbarcode';
import api from '../../api';

const BarcodeGenerator = () => {
  const [barcode, setBarcode] = useState('');
  const [error, setError] = useState(null);
  const canvasRef = useRef(null);

  const generate = async () => {
    try {
      console.log(`[${new Date().toISOString()}] [BarcodeGenerator] Generating barcode...`);
      const response = await api.get('/api/tools/barcode');
      const newBarcode = response.data.barcode;
      setBarcode(newBarcode);
      setError(null);
      JsBarcode(canvasRef.current, newBarcode, {
        format: 'UPC',
        width: 2,
        height: 100,
        displayValue: false
      });
      console.log(`[${new Date().toISOString()}] [BarcodeGenerator] Barcode generated: ${newBarcode}`);
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message;
      console.error(`[${new Date().toISOString()}] [BarcodeGenerator] Error:`, errorMsg);
      setError(`Failed to generate barcode: ${errorMsg}`);
      setBarcode('');
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(barcode);
    alert('Barcode copied to clipboard!');
    console.log(`[${new Date().toISOString()}] [BarcodeGenerator] Barcode copied: ${barcode}`);
  };

  return (
    <Container className="mt-5">
      <h2 className="mb-4">Barcode Generator</h2>
      {error && (
        <Alert variant="danger" onClose={() => setError(null)} dismissible>
          {error}
        </Alert>
      )}
      <Button variant="primary" onClick={generate} className="mb-3">
        Generate Barcode
      </Button>
      {barcode && (
        <div className="text-center">
          <canvas ref={canvasRef} className="mb-3"></canvas>
          <p>Barcode Value: {barcode}</p>
          <Button variant="secondary" onClick={copyToClipboard}>
            Copy to Clipboard
          </Button>
        </div>
      )}
    </Container>
  );
};

export default BarcodeGenerator;
